import React from "react";
import { TextSize } from "../components";
import { Text } from "./text";

interface OfferingRibbonProps {
  ribbonMessage: string;
  style?: React.CSSProperties;
  size?: TextSize;
}

export function OfferingRibbon(props: OfferingRibbonProps) {
  const { ribbonMessage, style, size = "md" } = props;

  return (
    // `offering-promo-ribbon` is a per-partner theming hook: WeWork restyles
    // this badge (flat corner instead of diagonal) in wework/wework_theme.css,
    // overriding the inline styles below. Re-check that file before changing
    // the positioning here.
    <div
      className="offering-promo-ribbon"
      style={{
        backgroundColor: "white",
        padding: 5,
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        width: 165,
        top: 40,
        left: 40,
        transform: "translate(-50%, -50%) rotate(-45deg)",
        ...style,
      }}
    >
      <div
        style={{
          textAlign: "center",
          width: 83,
        }}
      >
        <Text size={size} weight="bold">
          {ribbonMessage}
        </Text>
      </div>
    </div>
  );
}
